@if (!activeOnly || (activeOnly && !leftConversation)) {
  <div class="conversation-card">
    @if (!isHidden) {
      <div
        matRipple
        data-testid="conversation-card"
        [attr.data-conversation-id]="convo.id"
        [matRippleColor]="'rgba(0,0,0,0.04)'"
        class="convo-grid pt-1 pb-1"
        [ngClass]="{
          selected: selected,
          unread: $safeNavigationMigration(convo?.unreadMessageIds?.length),
        }"
        [@slideInOut]
      >
        <div class="left">
          @if (isScribeSidenav) {
            <app-scribe-icon [color]="'celoBrownGrey'"></app-scribe-icon>
          } @else {
            @if (type === "TeamChat" && !isRolesSidenav) {
              <app-roles-icon></app-roles-icon>
            } @else {
              <app-celo-avatar
                [width]="40"
                [height]="40"
                [type]="type"
                [participant]="participantToShow ? participantToShow : ''"
                [showBadge]="true"
                [conversationPictureUri]="
                  !!this.convo.photoId && !leftConversation ? pictureUri : null
                "
              ></app-celo-avatar>
            }
          }
        </div>
        <div class="mid">
          <div class="mid-contents">
            @if (convo.patientData && convo.type !== "External") {
              <div class="patient case-bubble celo-elipsis">
                <span class="case-title">Patient Case</span>
                <span class="case-content">
                  <span>{{
                    convo.patientData.uid ? convo.patientData.uid : ""
                  }}</span>
                  @if (
                    convo.patientData.uid &&
                    (convo.patientData.firstName || convo.patientData.lastName)
                  ) {
                    <span>, </span>
                  }
                  @if (
                    convo.patientData.firstName || convo.patientData.lastName
                  ) {
                    <span>
                      <span>
                        {{ convo.patientData.firstName }}
                        {{ convo.patientData.lastName }}
                      </span>
                    </span>
                  }
                </span>
              </div>
            }
            <div class="name-field">
              <div class="name celo-elipsis">
                <span>
                  {{
                    isRolesSidenav
                      ? participantToShow
                        ? participantToShow.firstName +
                          " " +
                          (participantToShow.lastName ?? "")
                        : "User"
                      : name
                  }}
                </span>
              </div>
              @if (type === "SelfChat") {
                <div>&nbsp;(You)</div>
              }
            </div>
            @if (convo.lastMessage && !hideLastMessage) {
              <div class="last-message celo-elipsis">
                @if (convo.participants && convo.participants.length > 0) {
                  <span>
                    @if (type !== "Chat") {
                      <span>
                        <span class="sender-name"
                          >{{
                            getParticipantNameById(convo.lastMessage.sentBy)
                          }}:
                        </span>
                      </span>
                    }
                    @if (type === "Chat") {
                      <span>
                        @if (
                          convo.lastMessage.sentBy !== "SYSTEM" &&
                          convo.lastMessage.sentBy === userAccount.userId
                        ) {
                          <span class="sender-name"
                            >{{
                              getParticipantNameById(convo.lastMessage.sentBy)
                            }}:
                          </span>
                        }
                      </span>
                    }
                  </span>
                }
                @if (
                  (!convo.lastMessage.type ||
                    convo.lastMessage.type === "UserConnected") &&
                  convo.lastMessage?.content
                ) {
                  <span class="content">
                    {{ convo.lastMessage.content }}
                  </span>
                }
                @if (convo.lastMessage.type === "Photo") {
                  <span class="last-message-file">
                    <span class="last-message-child">
                      @if (
                        convo.lastMessage.mediaType === "Photo" ||
                        !convo.lastMessage.mediaType
                      ) {
                        <span class="message-type">Photo</span>
                      }
                      @if (convo.lastMessage.mediaType === "Video") {
                        <span class="message-type">Video</span>
                      }
                      @if (convo.lastMessage.mediaType === "Audio") {
                        <span class="message-type">Audio</span>
                      }
                      @if (
                        convo.lastMessage.mediaType === "Photo" ||
                        !convo.lastMessage.mediaType
                      ) {
                        <img
                          [src]="
                            '/api/v2/media/' +
                              convo.lastMessage.metadata.photoId +
                              '?size=Small'
                              | clink
                              | secure
                          "
                        />
                      }
                      @if (convo.lastMessage.mediaType === "Video") {
                        <mat-icon>videocam</mat-icon>
                      }
                      @if (convo.lastMessage.mediaType === "Audio") {
                        <mat-icon>mic</mat-icon>
                      }
                    </span>
                  </span>
                }
                @if (convo.lastMessage.type === "VideoCall") {
                  <span class="last-message-video-call">
                    <span class="last-message-child">
                      <span>{{ convo.lastMessage.content }}</span>
                      <!-- <span class="video-call-icon-container"><mat-icon>videocam</mat-icon></span> -->
                    </span>
                  </span>
                }
                @if (convo.lastMessage.type === "PatientFile") {
                  <span class="last-message-photo">
                    <span>Document</span>
                  </span>
                }
              </div>
            }
            @if (showParticipants) {
              <div class="last-message celo-elipsis">
                @if (convo.participants && convo.participants.length > 0) {
                  <span>
                    @for (
                      participant of convo.participants;
                      track participant;
                      let index = $index
                    ) {
                      <span class="sender-name">
                        @if (index < 10 && !participant.leftOnUtc) {
                          <span
                            >{{ participant.firstName }}
                            @if (index < convo.participants.length - 1) {
                              <span>, </span>
                            }
                          </span>
                        }
                      </span>
                    }
                  </span>
                }
              </div>
            }
          </div>
        </div>
        <div class="right">
          <div class="timestamp">
            {{
              (convo.lastMessage?.sentOnUtc
                ? convo.lastMessage.sentOnUtc
                : convo.lastMessage?.createdOnUtc
                  ? convo.lastMessage.createdOnUtc
                  : convo.createdOnUtc
              ) | dateFormat: "light"
            }}
          </div>
          @if (inConversationList) {
            <div class="notification-archive-container">
              @if (!isRolesSidenav && !disableConversationActions) {
                <span class="settings-button">
                  <i
                    class="material-icons"
                    role="button"
                    aria-label="Conversation settings"
                    (click)="$event.stopPropagation(); (false)"
                    matTooltip="Settings"
                    [matMenuTriggerFor]="appMenu"
                  >
                    settings
                  </i>
                </span>
                @if (isMuted) {
                  <span>
                    <i
                      [ngClass]="{ slide_r_0_4: isMuted }"
                      matTooltip="Muted"
                      data-testid="conversation-muted-status"
                      class="material-icons muted-icon"
                    >
                      volume_off
                    </i>
                  </span>
                }
                @if (isPinned) {
                  <mat-icon
                    [svgIcon]="'icon-pin'"
                    [ngClass]="{ slide_r_0_4: isPinned }"
                    class="pin-icon"
                    matTooltip="Pinned"
                  ></mat-icon>
                }
                <mat-menu #appMenu="matMenu">
                  @if (!isMuted) {
                    <button mat-menu-item (click)="openMuteDialog()">
                      <mat-icon [svgIcon]="'icon-mute'"></mat-icon>
                      <span class="menu-item">Mute</span>
                    </button>
                  }
                  @if (isMuted) {
                    <button mat-menu-item (click)="unMuteConversation()">
                      <mat-icon
                        [svgIcon]="'icon-unmute'"
                        matTooltip="Unmute"
                      ></mat-icon>
                      <span class="menu-item">Unmute</span>
                    </button>
                  }
                  @if (!isPinned) {
                    <button mat-menu-item (click)="pinConversation(convo)">
                      <mat-icon [svgIcon]="'icon-pin'"></mat-icon>
                      <span class="menu-item">Pin</span>
                    </button>
                  }
                  @if (isPinned) {
                    <button mat-menu-item (click)="unpinConversation(convo)">
                      <mat-icon [svgIcon]="'icon-unpin'"></mat-icon>
                      <span class="menu-item">Unpin</span>
                    </button>
                  }
                  @if (!hideArchiveOption) {
                    <button mat-menu-item (click)="hideConvo(convo)">
                      <mat-icon [svgIcon]="'icon-archive'"></mat-icon>
                      <span class="menu-item">Archive chat</span>
                    </button>
                  }
                  @if (!hideUnreadCount) {
                    <button mat-menu-item (click)="markReadDialogue(convo)">
                      <mat-icon [svgIcon]="'icon-clear-badge'"></mat-icon>
                      <span class="menu-item">Clear unread badge</span>
                    </button>
                  }
                </mat-menu>
              }
              <span>
                @if (convo?.unreadMessageIds?.length && !hideUnreadCount) {
                  <div
                    [ngClass]="{ slide_r_0_4: convo.unreadMessageIds.length }"
                    class="notification"
                  >
                    <div>
                      {{ convo.unreadMessageIds.length }}
                    </div>
                  </div>
                }
              </span>
            </div>
          }
        </div>
      </div>
    }
    @if (!hideBorder) {
      <div class="line">
        <div class="celo-border-bottom"></div>
      </div>
    }
  </div>
}
